import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Container } from "react-bootstrap";
import { LoadingComponent } from "../../Components/Loading";
import { Woo } from "../../Helpers/Woo";
import { ProductPageComponent } from "./ProductPageComponent";
import { StyledBackButton } from "./style.css";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "../../Shared/Hooks/useLocalStorage";

function ProductPage() {
  const ls = useLocalStorage();
  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(true);
  const { productId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    let currentProd = null;
    const lsProducts = ls.getJSON("products");
    if (lsProducts) {
      for (const lsProduct of lsProducts) {
        if (lsProduct.slug === productId) {
          currentProd = lsProduct;
          setProduct(lsProduct);
          setLoading(false);
        }
      }
    }

    if (currentProd === null) {
      Woo.products.find(productId)
        .then((data) => {
          setProduct(data);
          setLoading(false);
        })
        .catch((e) => {
          console.warn(e);
          setLoading(false);
        });
    }
  }, []);

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <Container className="py-3">
      <StyledBackButton
        role="button"
        onClick={() => navigate(-1)}
        className="d-inline-flex align-items-center gap-1 mb-3"
      >
        &larr; {t("Volver")}
      </StyledBackButton>
      <ProductPageComponent product={product} />
    </Container>
  );
}

export default ProductPage;
